<style scoped lang="scss">
@import "$vars";
.column {
  padding-top: 5px;
  padding-bottom: 5px;
}
.form-radio {
  font-size: 1em !important;
  .form-icon {
    margin-top: 7px
  }
  cursor: pointer
}
.array {
  align-items: start;
  ul {
    padding-left: 5px
  }
  .form-add {
    border-radius: 50%;
    border: 3px solid $color-blue;
    color: white;
    background: $color-blue;
    right: 0.7rem;
  }
}

.form-switch {
  margin: -20px 0 -10px 130px;
}
textarea {
  resize: none;
  width: 100%;
}
.chips {
  li {
    white-space: normal;
    max-width: 100%;
    font-size: 1em;
    padding: 5px
  }
}
.chip-close {
  color: white;
  >i {
    vertical-align: baseline
  }
}
.form-checkbox {
  line-height: 0.5rem;
}
.selectMultiple {
  input {
    background: #f1f1f1 !important;
  }
  ul {
    position: absolute;
    background: #f1f1f1;
    width: 100%;
    z-index: 100;
    box-shadow: 2px 5px 5px rgba(0,0,0,0.2);
    li {
      margin: 0;
      align-items: center;
      label {
        padding: 10px 5px;
        margin: 0;
        display: flex;
        i {
          position: relative
        }
      }
      a {
        padding-bottom: 3px;
        width: 100%;
      }
    }
    .icon {
      color: $color-blue;
      cursor: pointer
    }
    li:hover {
      background: white
    }
  }
}
.flex-nowrap {
  label {
    white-space: nowrap
  }
}

.viewPassword {
  position: absolute;
  right: 5px;
  top: 5px;

  &__icon {
    display: flex;
    height: 25px;
    width: 25px;

    figure {
      flex: 1 1 auto;
    }
  }
}
.text-warning {
  span{
  font-size: 0.7em;
  }
  li{
  line-height: 0.5em;
  }
}
.activePrinciples{
  width: 97% !important;
  .form-input{
    width: 100%;
  }
}

.disabled-list {
  &:not(:first-of-type) {
    margin-top: 0.5rem;
  }
}
</style>

<template>
  <transition name="fade">
  <div
    class="column form-group has-icon-right field"
    :class="[sizeClasses, errorClass, successClass, (field.classes ? field.classes.join(' ') : '')]"
    :style="getOffset"
    v-show="!field.hide"
  >
    <label
      v-if="validators"
      :for="prefix+'_'+field.name"
      class="form-label left"
    >
      {{ field.label }}
      <dr-tooltip
        v-if="field.tooltip"
        :text="field.tooltip"
      />
    </label>

    <label
      v-else-if="(field.label || '').length > 0"
      :for="prefix+'_'+field.name"
      class="form-label left"
    >
      {{ field.label }}
      <dr-tooltip
        v-if="field.tooltip"
        :text="field.tooltip"
      />
    </label>

    <div class="has-icon-right" :class="field.addOn ? 'input-group' : ''" v-if="!field.hidden">
      <span v-if="field.addOn" class="input-group-addon">R$</span>
      <input
        v-if="
          noTextInputs.indexOf(field.type) === -1 &&
          field.type !== 'select' &&
          field.type !== 'list'
        "
        v-model="field.value"
        v-mask="getMask"
        class="form-input"
        :id="prefix+'_'+field.name"
        :type="field.type"
        :placeholder="field.placeholder"
        :required="field.required"
        :readonly="field.readonly"
        :disabled="field.disabled"
        :maxlength="('maxlength' in field) ? field.maxlength : ''"
        @focus="reset(); field.onFocus ? field.onFocus() : ''"
        @blur="touch(); field.onBlur ? field.onBlur() : ''"
        @change="field.onChange ? $emit('changed', true) : ''"
      />

        <!-- button: show password -->
        <div v-if="showPasswordIcon === true && field.value" class="viewPassword">
          <div v-if="!showPassword">
            <span
              @click="showPassword = !showPassword; field.type = 'text';"
              class="clickable viewPassword__icon"
            >
              <dr-icon
                name="visibilityOn"
                fill="#56bdd2"
                color="#56bdd2"
              />
            </span>
          </div>
          <div v-else>
            <span
              @click="showPassword = !showPassword; field.type = 'password';"
              class="clickable viewPassword__icon"
            >
              <dr-icon
                name="visibilityOff"
                fill="#56bdd2"
                color="#56bdd2"
              />
            </span>
          </div>
        </div>
        <!-- /button: show password -->

      <div v-if="field.type === 'currency'" class="input-group">
        <span class="input-group-addon">R$&nbsp;</span>
        <input
          v-model="field.value.converted"
          :id="prefix+'_'+field.name"
          :ref="prefix+'_'+field.name"
          :placeholder="field.placeholder"
          :required="field.required"
          :readonly="field.readonly"
          :disabled="field.disabled"
          maxlength="9"
          class="form-input"
          type="text"
          autocomplete="off"
          @keypress="fn_FORMAT_CURRENCY($event, field.value)"
          @keydown="fn_FORMAT_CURRENCY($event, field.value)"
          @focus="reset()"
          @blur="touch()"
        />
      </div>
      <div
        v-else-if="field.type === 'radio'"
        :class="wrap === false ? '' : 'flex-wrap'"
        class="d-flex"
      >
        <label v-for="(radio, $index) of field.radios" :key="$index" class="form-radio">
          <input
            type="radio"
            :disabled="field.disabled ? field.disabled : radio.disabled "
            :id="prefix+'_'+radio.name"
            :name="radio.name"
            :value="radio.value"
            :checked="field.value === radio.value"
            v-model="field.value"
            />
          <i class="form-icon"></i> {{radio.label}}
        </label>
      </div>
      <div v-else-if="field.type === 'checkbox'" class="d-flex">
        <label v-for="(checkbox, $index) of field.checkboxes" :key="$index" class="form-checkbox" :class="checkbox.class || ''">
          <input
            type="checkbox"
            :id="prefix+'_'+checkbox.name"
            :name="field.name"
            :value="checkbox.value"
            :checked="field.value.indexOf(checkbox.value) > -1"
            v-model="field.value" />
          <i class="form-icon"></i>&ensp;{{checkbox.label}}
        </label>
      </div>
      <div v-else-if="field.type === 'switch'" class="d-flex">
        <label class="form-switch">
          <input
            type="checkbox"
            :id="prefix+'_'+field.name"
            :name="field.name"
            :value="field.value"
            :checked="field.value === field.value"
            v-model="field.value"
            />
          <i class="form-icon"></i>
        </label>
      </div>
      <select
        v-else-if="field.type === 'select'"
        v-model="field.value"
        class="form-select"
        :id="prefix+'_'+field.name"
        :class="field.value === 0 ? 'placeholder' : ''"
        :required="field.required"
        :readonly="field.readonly"
        :nultiple="field.multiple"
        :disabled="field.disabled"
        @change="field.onChange ? $emit('changed', true) : ''"
        >
        <option v-if="field.placeholder" :key="0" :disabled="true" :value="null">{{field.placeholder}}</option>
        <option
          v-for="(option, index) of field.options.filter(o => !o.hidden)"
          :key="'opt' + option.id + option.name + index"
          :value="option.id"
          >{{option.name}}</option>
      </select>
      <div v-else-if="field.type === 'selectMultiple'" class="selectMultiple">
        <label v-if="field.options.length" @mouseleave="field.collapsed = false">
          <input
            @click="field.collapsed = !field.collapsed"
            type="text"
            readonly
            class="form-select clickable"
            :value="field.placeholder + (field.value.length > 0 ? ` (${field.value.length})` : '')" />
          <ul v-if="field.collapsed" class="list-unstyled">
            <li v-for="(option, $index) of field.options" :key="`multiple_opt_${$index}`" class="d-flex">
              <label
                :for="`multiple_opt_${$index}`" class="form-checkbox" >
                <input
                  type="checkbox"
                  :id="`multiple_opt_${$index}`"
                  :name="field.name"
                  :value="option.id"
                  :checked="field.value === option.id"
                  v-model="field.value"
                  />
                <i class="form-icon"></i> </label>
                <i @click="$emit('clicked', option.id)" class="icon icon-edit"></i>
                &ensp;
                <a @click="$emit('clicked', option.id)">{{option.name}}</a>
            </li>
          </ul>
        </label>
      </div>
      <textarea
        v-else-if="field.type === 'textarea'"
        v-model="field.value"
        :rows="field.rows || 3"
        class="form-input"
        :id="prefix+'_'+field.name"
        :class="field.value === 0 ? 'placeholder' : ''"
        :placeholder="field.placeholder"
        :required="field.required"
        :readonly="field.readonly"
        :disabled="field.disabled"
        :maxlength="('maxlength' in field) ? field.maxlength : ''"
        >
      </textarea>
      <div v-else-if="field.type === 'array'" class="d-flex columns array">
        <section class="has-icon-right column col-4 activePrinciples">
          <input type="text"
            v-model="arrayField"
            :rows="field.rows || 3"
            class="form-input"
            :id="prefix+'_'+field.name"
            :class="field.value === 0 ? 'placeholder' : ''"
            :required="field.required"
            :readonly="field.readonly"
            :disabled="field.disabled"
            :placeholder="field.placeholder"
            @keypress="keyCheck($event)"
          />
          <i
            v-show="arrayField"
            class="form-icon form-add clickable icon icon-plus"
            @click="arrayAdd(arrayField)"
          />
        </section>
        <ul class="list-unstyled column col-8 chips">
          <transition-group name="fade">
          <li v-for="(item, $index) in getArraySelected" :key="'array_'+$index" class="chip">
            {{item.name}}&ensp;
            <a @click="arrayRemove(item.name)" class="chip-close" aria-label="Close" role="button"><i class="icon icon-cross"></i></a>
          </li>
          </transition-group>
        </ul>
      </div>
      <div v-else-if="field.type === 'date'">
        <dr-datepicker
          @selected="$emit('dateSelected', $event)"
          class="form-date "
          input-class="form-input"
          :id="prefix+'_'+field.name"
          :readonly="field.readonly"
          :disabled="field.disabled"
          v-model="field.value" />
      </div>
      <div v-else-if="field.type === 'search'">
        <drAutocomplete
          :disabled="field.disabled"
          :ref="field.name"
          :disable-local="field.disableLocal"
          :endpoint="field.endpoint"
          :format="field.format"
          :return-format="field.returnFormat"
          :fields="field.fields"
          :placeholder="field.placeholder"
          @cleared="$emit('cleared', true)"
          @change="field.value = $event"
          @typed="field.value = $event"
        />
      </div>

      <div v-else-if="field.type === 'list'">
        <input
          v-for="(option, index) in field.options"
          :key="`disabled-list-${index}`"
          :value="String(option.name).toUpperCase()"
          :disabled="true"
          class="form-input disabled-list"
        />
      </div>

      <i v-if="field.loading === 1" class="form-icon loading"></i>
    </div>
    <div v-else>
      <input
        v-model="field.value"
        @blur="touch()"
        @focus="reset()"
        :id="prefix+'_'+field.name"
        :ref="prefix+'_'+field.name"
        :type="'hidden'"
      />
    </div>
    <ul v-if="validators && !field.hideErrors" class="list-unstyled">
      <li v-for="(error, index) in validators.value.$params" :key="index">
        <span v-if="index === 'required' && !validators.value['required'] && validators.value.$dirty" class="form-input-hint">
          {{getErrors[index] || 'Campo em branco'}}
        </span>
        <span v-else-if="index !== 'required' && (validators.value.$invalid && field.value && !validators.value[index] && validators.value.$dirty)" class="form-input-hint">
          {{getErrors[index] || 'Campo inválido'}}
        </span>
      </li>
    </ul>
    <ul v-if="field.warnings" class="list-unstyled text-warning">
      <li v-for="(warning, index) in field.warnings" :key="'w' + index">
        <span class="form-input-hint" :class="validators.value[index] && (field.value || '').length  > 0 ? 'text-success' : ''">
        &#8226; {{warning}}
        </span>
      </li>
    </ul>
    <template v-if="getApiErrors.length > 0">
      <span v-for="error of getApiErrors"  :key="error" class='form-input-hint text-error' >{{error}}</span>
    </template>
  </div>
  </transition>
</template>

<script>
import drTooltip from '@/components/tooltip'
import drAutocomplete from '@/components/form/autocomplete'

export default {
  props: [
    'field',
    'validators',
    'apiErrors',
    'value',
    'prefix',
    'form',
    'showPasswordIcon',
    'editedValue',
    'wrap'
  ],

  components: {
    drTooltip,
    drAutocomplete
  },

  data () {
    return {
      loaded: false,
      noTextInputs: [
        'radio', 'checkbox', 'switch', 'textarea', 'array', 'currency', 'date', 'selectMultiple', 'search'
      ],
      arrayField: null,
      arraySelected: [],
      showPassword: false
    }
  },

  computed: {
    getArraySelected: {
      get () {
        return this.arraySelected
      },
      set (v) {
        this.arraySelected = v
      }
    },
    sizeClasses () {
      let classes = ''
      classes = ` col-${this.field.size > 0 ? this.field.size : 12} col-sm-12`
      return classes
    },
    getMask () {
      return Array.isArray(this.field.mask)
        ? [...this.field.mask]
        : this.field.mask || { mask: '*'.repeat(255), tokens: { '*': { pattern: /./ } } }
    },
    getOffset () {
      return this.field.offset ? `margin-right: ${(100 / 12) * this.field.offset}%` : ''
    },
    errorClass () {
      if (!this.validators) {
        return
      }
      if ((this.validators.$invalid && this.validators.$dirty) || this.getApiErrors.length > 0) {
        return 'has-error'
      }
      if (this.validators.$invalid && !this.validators.value.$params.required) {
        return 'has-error'
      }
      return null
    },
    successClass () {
      if (!this.validators) {
        return
      }
      if (!this.validators.$invalid && this.field.hasSuccess) {
        return 'has-success'
      }
      return null
    },
    getErrors () {
      return this.field.errors || []
    },
    getApiErrors () {
      return this.apiErrors || []
    }
  },

  watch: {
    'field.value': {
      deep: true,
      immediate: true,
      handler () {
        if (this.field.type === 'array') {
          this.arrayCheck()
        }
      }
    }
  },

  mounted () {
    this.arrayCheck()
  },

  methods: {
    keyCheck (ev) {
      if (ev.key.toUpperCase() === 'ENTER') {
        ev.preventDefault()
        this.arrayAdd(this.arrayField)
      }
    },
    arrayAdd (item) {
      if (!item || item.trim().length === 0) {
        return
      }
      if (!this.arraySelected) {
        this.arraySelected = []
      }
      for (let selected of this.arraySelected) {
        if (item.toUpperCase() === selected.name.toUpperCase()) {
          return
        }
      }
      this.arraySelected.push({
        name: item
      }
      )
      this.arrayField = null
      this.field.value = this.getArraySelected
      // this.arrayPrepare()
    },
    arrayRemove (v) {
      this.getArraySelected = this.fn_REMOVE_FROM_ARRAY(this.arraySelected, v, 'name')
      this.field.value = this.getArraySelected
    },
    arrayPrepare () {
      let arr = []
      for (let field of this.getArraySelected) {
        arr.push({
          name: field
        })
      }
      this.field.value = arr
    },
    arrayCheck () {
      if (this.field.type === 'array') {
        this.getArraySelected = null
        this.getArraySelected = this.field.value
      } else if (this.field.type === 'checkbox') {
        this.field.value = [this.field.value]
      }
    },
    touch () {
      if (this.validators) {
        if (this.validators.value.hasOwnProperty('required')) {
          this.validators.$touch()
        }
      }
    },
    reset () {
      this.$emit('focused', true)
      if (this.validators) {
        this.validators.$reset()
      }
    }
  }
}
</script>
